import React, {useContext,  useReducer, useRef, useState} from 'react';
import {Button, Checkbox, Drawer, Dropdown, message, Select, Space, Spin, Switch, Tag, Tooltip,} from 'antd';

import TagGroup from "../uiUtils/TagGroup";
import {MccTypeAhead} from './MccTypeAhead';

import {defer, difference, invert, isArray, merge, omit, pick, range,
    includes} from "lodash";
import {ClientBridge} from "../index";
import {AssetCard} from "../uiUtils/ItemCard";
import {Pager} from "../uiUtils/Helpers";
import {Spread} from "../uiUtils/Spread";
import {ArrowLeftOutlined, ArrowRightOutlined, DownOutlined, PlusOutlined, UndoOutlined} from "@ant-design/icons";
import {calcFirstRow, calcNewPage} from "../Wizard/utils";
import {useMccSearch} from "./mccHooks";
import Splash from "./Splash";
import getMailLinkMenu from "../uiUtils/MailLinkMenu";
import {useModelItem} from "../model/modelHooks";


// Best OUSTIDE of React Function else the reducer is called twice (works but annoying)
// todo make generic searchReducer
const reducer = (oldState, action) => {

    const newState = Object.assign({},oldState);
    newState.splash = false;

    switch (action.type) {
        case 'forceUpdate':
            return newState;
        case 'reset' :
            return action.value;
    }

    if ( !action.field) {
        throw new Error("Missing field");
    }
    if ( !(action.field in oldState) ) {
        // i.e. Only support fields in initial state
        throw new Error("Unknown field: ", action.field);
    }

    switch (action.type) {
        case 'remove':
            if (!oldState[action.field].includes(action.value)) {
                if (oldState.splash) break;
                return oldState;
            }
            newState[action.field] = oldState[action.field].filter(tag => tag !== action.value);
            break;
        case 'add':
            if (oldState[action.field].includes(action.value)) {
                if (oldState.splash) break;
                return oldState;
            }
            newState[action.field] = oldState[action.field].concat([action.value]);
            break;
        case 'replace':
            // Todo use compareArray
            if (oldState[action.field] === action.value) {
                if (oldState.splash) break;
                return oldState;
            }
            newState[action.field] = action.value;
            break;
        default:
            throw new Error("Unspported reducer action" );
    }


    if (action.field === 'pageSize') {
        // ensure the record at the start of the current is still visible
        //const oldStart = oldState.pageSize * (oldState.page-1) + 1;
        //newState.page =  Math.floor((oldStart-1)/ newState.pageSize)+1;
        newState.page = calcNewPage({
            newPageSize: newState.pageSize,
            pageSize: oldState.pageSize,
            currentPage: oldState.page
        });
    }
    else if (action.field !== 'page') {
        newState.page=1;
    }

    return newState;
};

//todo - label ALL web ads as u20 web ads (or campaign)
//  - then can search just for campaign ads

const sortOrders = ['best','popular','latest'];
const sortLabels = {
    best: 'Best Match',
    popular: 'Most Popular',
    latest: 'Most Recent'
};

const initialState = {
    keyword:[],
    notword:[],
    exactMatch:false,
    holiday:false,
    medium:['Print'],
    //printWithWeb:[],
    orientation:[],
    //printAdType:[],
    printAdSize:[],
    webAdSize:[],
    page:1,
    pageSize: 20,
    sortOrder:sortOrders[0],
    splash: true
};

const excludedTypes = []
/*
// Note search filters should not have spaces - not sure this was working properly anyway
const excludedTypes = ['multipleadvertiser','multiplelisting','couponpage',
    'directory','marketplace','bonusideas','calendar','coloring pages', 'grocery/market',
    'contest', 'quicksellpage', 'metrobiz', 'campaign', 'infographics', 'themed event package'
];
 */

const excludedSizes = ['postcard', 'broadsheet', 'doubletruck']; // just not many of these

const maxSubItemCount = 6;

export default function TemplateSearch(
    {
        onSelect,
        advertiser
    })
{

    const typeAheadRef = useRef(null);
    const [drawer, setDrawer] = useState(false);
    const {mcc, active, mccAuth} = useContext(ClientBridge);
    const [loginPerson] = useModelItem('person', 'selected_login');
    const baseFilters = ['orientation'];
    const [activeFilters, setActiveFilters] = useState(baseFilters);
    const [query, setQuery] = useState();

    // todo get this const out of the function ? but uses client bridge
     const filters = {
        medium: {
            label: 'Ad Medium',
            tag: 'BOOLp53',  //deprecated
            name: 'medium', //'file_ext',  // name used in mcc.api
            color: 'purple',
            values: {  // ?? organized so print is the default
                'print': 'Print',
                'printwithweb': 'Print with web',
                'web': 'Web',
                // 'all': 'All'
            },
            Xvalues: {
                'qxd@qxp': 'Print',
                'qxd@qxp@web': 'Print with web',  // fudge @web is a NOP but makes unique prop name
                'psd@jpg': 'Web'
            }
        },
        orientation: {
            label: 'Orientation',
            tag: 'BOOLp32',
            name: 'aspect_ratio',
            color: 'blue',
            values: {
                '100:1@95:1@90:1@85:1@80:1@75:1@70:1@65:1@60:1@55:1@50:1@45:1@40:1@35:1@30:1@25:1@20:1@15:1@10:1@9:1@8:1@7:1@6:1@5:1@4:1@3:1@2:1@3:2@4:3@5:4@6:5@7:6@8:7@9:8@1:1':
                    'Horizontal',
                '1:1@8:9@7:8@6:7@5:6@4:5@3:4@2:3@1:2@1:3@1:4@1:5@1:6@1:7@1:8@1:9@1:10@1:15@1:20@1:25@1:30@1:35@1:40@1:45@1:50@1:55@1:60@1:65@1:70@1:75@1:80@1:85@1:90@1:95@1:100':
                    'Vertical'
            }
        },
        printWithWeb: {  // NOTE: no longer exposed in UI separately - parsed from expanded medium
            label: 'Campaign',
            tag: 'BOOLu25',
            name: 'extra',
            color: 'DarkKhaki',
            values: { 'web ad':'With web ads'}
        },
         /*
        printAdType: {
            label: 'Ad Type',
            tag: 'BOOLp85',
            name: 'ad_type',
            color: 'MediumOrchid',
            values: omit(mcc.values.print_ad_type, excludedTypes)
        },
          */
        printAdSize: {
            label: 'Ad Size',
            tag: 'BOOLp43',
            name: 'ad_size',
            color: 'orange',
            values: omit(mcc.values.print_ad_size, excludedSizes)
        },
        webAdSize: {
            label: 'Ad Size',
            tag: 'BOOLp43',
            name: 'web_ad_size',
            color: 'orange',
            values: mcc.values.web_ad_size
        }
    };

    React.useLayoutEffect(() => {
        // Drawer doesn't render until open
        // and even then first useEffect fires before drawer children render
        if (drawer) {
            defer((ref) => {
                if (ref.current) {  //might not need this in defer..
                    ref.current.focus();
                    ref.current.clear();
                }
            }, typeAheadRef);
        }
    }, [drawer]);

    /* todo ? control with pref?
    useEffect(()=>{
        resetSearch({
            keyword: get(advertiser, 'adSeller.advertiser.metroBiz.keyword','')
                .split(/\s+/).filter(w=>w)  // filter gets rid of empty entries
        });
    },[advertiser]);
     */

    const [state, dispatch] = useReducer(reducer, initialState);

    const resetSearch = addState => {
        setData();
        dispatch({
            type:'reset',
            value: merge({},initialState, addState)
        });
    }

    const removeKeyword = (removedTag) => {
        dispatch({type:'remove',field:'keyword',value:removedTag});
    };
    const removeNotword = (removedTag) => {
        dispatch({type:'remove',field:'notword',value:removedTag});
    };
    const addKeyword = (term, search) => {
        if (term.match(/\S/)) {
            if (search.match(/^\W*-/)) {
                dispatch({type: 'add', field: 'notword', value: '-' + term});
                dispatch({type: 'remove', field: 'keyword', value: term});
            } else {
                dispatch({type: 'add', field: 'keyword', value: term});
                dispatch({type: 'remove', field: 'notword', value: '-' + term});
            }
        } else {
            dispatch({type:'forceUpdate'});
        }
        typeAheadRef.current.clear();
    };

    const removeFilter = (field, value) => dispatch({type:'remove',field,value});
    const onFilterChange = (field, value) => {

        // This fudges rolling PrintWithWeb into medium check box values
        if (field==='medium' && value.length > 1) {
            if (includes(state['medium'], 'Print with web')) {
                value = difference(value,['Print with web']);
            } else if (includes(value, 'Print with web')) {
                value = ['Print with web'];
            } else {
                // todo - zero P&W?
            }
        }

        // don't allow all on at once - means all?
        const all = Object.values(filters[field].values);
        if (value.length === all.length) {
            value = difference(all, state[field]); // invert
        }
        dispatch({type:'replace',field,value});
    };

    const onPageChange = (page, pageSize)=>{
        dispatch({type:'replace',field:'page',value:page});
    };
    const onPageSizeChange = (old, newSize)=>{
        dispatch({type:'replace',field:'pageSize',value:newSize});
    };

    const {data: result, isPending:loading, setData} = useMccSearch(query);

    React.useEffect( ()=> {
        if (drawer) {
            typeAheadRef.current.forceReturn();
            // bag unactivated text in the keyword field (or it disappears)
        }
    }, [drawer]);

    React.useEffect( ()=> {
        if (typeAheadRef.current.forceReturn()) {
            return; // unactivated text in the keyword field
        }

        let queryData = state;
        let newFilters = baseFilters;
        if (state.medium.length > 0) {
            if (state.medium[0] === 'Web') {
                newFilters.push('webAdSize');
            } else if (state.medium[0].startsWith('Print')) {
                //newFilters.push('printWithWeb');
                newFilters.push('printAdSize');
                //newFilters.push('printAdType');
            }
        }
        setActiveFilters(newFilters);

        // fudge as print with web combined with medium
        if (state.medium[0] === 'Print with web') {
            newFilters = newFilters.concat(['printWithWeb']);  // build new array so we don't effect state
            queryData = {
                ...state,
                printWithWeb: ['With web ads'],
                medium: ['Print'] // overwrites
            }
        }
        if (state.medium.length > 0) {
            newFilters = newFilters.concat(['medium']); // fudge as no longer baseFilter
        }

        if (!state.splash) {
            const queryInfo = getApiMccInfo({queryData, newFilters, filters});
            setQuery(queryInfo);
        }
    }, [state]);

    React.useEffect( ()=>{
        if (result){
            if (result.status==='failed') {
                console.log(result.error.message);
                message.error('Searched failed. Please try again');
            }
        }
    }, [result]);

    const getRequestMenu = textQuery => getMailLinkMenu({
        subject:"User Request",
        to:"u-tell-us@metro-email.com",
        body:"\r\n\r\nTell us what you would like to see in the library in the future."
        + "\r\n".repeat(4) + "Search\r\n" + textQuery
        +"\r\n\r\nUser: " + loginPerson.displayName
    });


    // todo Add Seasonal 'Holiday Only' Filter
    //  - Need access to the use services - mccLogin.standardService
    return (
        <div style={{marginRight:10}}>
            <style dangerouslySetInnerHTML={{__html: `
                .drawer-form .ant-checkbox-group-item {
                    display: block;
                }
            `}} />

            <Drawer
                title="Filters"
                placement="right"
                closable={true}
                onClose={()=>setDrawer(false)}
                visible={drawer && active}
                className='drawer-form'
                zIndex={1010}
                width={280}
                bodyStyle={{backgroundColor:'whitesmoke'}}
            >
                {activeFilters.map(field=>(
                    <FilterCheckbox key={field}
                            label={filters[field].label}
                            options={Object.values(filters[field].values)}
                            value={state[field]}
                            onChange={value=>onFilterChange(field,value)}/>
                ))}
            </Drawer>

            <Spin spinning={loading} delay={500} size="large" >
                <Space align="center">
                    <Button title={'refresh search'}
                            onClick={()=>dispatch({type:'forceUpdate'})}
                            type={'primary'}
                            size={'small'}
                    >Search</Button>
                    <span style={{marginLeft:5}}>Keywords: </span>
                    <Tooltip title={"Enter keywords or filenames. Use a '-' before a keyword to exclude it"}>
                        <MccTypeAhead onSelect={addKeyword}
                                      placeholder="keyword search"
                                      ref={typeAheadRef}
                                      size={'small'}
                        />
                    </Tooltip>
                    <span style={{marginLeft:5}}>Exact match </span>
                    <Switch size="small" checked={state.exactMatch}
                            onChange={()=>dispatch({type:'replace',field:'exactMatch',value:!state.exactMatch})}/>
                    <TagGroup
                        tags={state.keyword}
                        onRemoveTag={removeKeyword}
                        color='green'
                    />
                    <TagGroup
                        tags={state.notword}
                        onRemoveTag={removeNotword}
                        color='red'
                    />
                    <span style={{marginLeft:5}}></span>
                    <Tooltip title={'Choose web ads with “Ad Options” button in Step 3'}>
                        <Select onChange={value=>dispatch({type:'replace',field:'medium',value:value?[value]:[]})}
                            value={state.medium[0]||''}
                            size={'small'}
                            style={{width:132}}
                        >
                            <Select.Option value={''}>All ads</Select.Option>
                            <Select.Option value={'Print'}>Print only</Select.Option>
                            <Select.Option value={'Print with web'}>Print with web</Select.Option>
                            <Select.Option value={'Web'}>Web only</Select.Option>
                        </Select>
                    </Tooltip>
                    {activeFilters.map(field=>
                        <TagGroup
                            key={field}
                            tags={state[field]}
                            onRemoveTag={value=>removeFilter(field,value)}
                            color={filters[field].color}/>
                    )}
                    {mccAuth.hasService('has') && new Date().getMonth()>=7 &&
                        <span style={{marginLeft:5}}>
                            <span style={{color:'green'}}>Holiday Only </span>
                            <Switch size="small" checked={state.holiday}
                                onChange={()=>dispatch({type:'replace',field:'holiday',value:!state.holiday})}/>
                        </span>
                    }
                    <Tag
                            onClick={()=>setDrawer(true)}
                            style={{ backgroundColor: '#fff', margin:4 }}
                        >
                        <PlusOutlined />More Filters
                    </Tag>
                </Space>

                {state.splash
                    ? <Splash/>
                    : (result && result.total) ?
                    <>
                        <Spread style={{background: '#EEE', borderRadius:5}}
                            left={<>
                                <span style={{marginRight:10}}>
                                    Sort by:
                                    <Select value={state.sortOrder} size='small' style={{margin:5, width:120}}
                                            onChange={(order)=>dispatch({type:'replace',field:'sortOrder',value:order})}
                                    >
                                        {sortOrders.map(order => (
                                            <Select.Option key={order} value={order}>{sortLabels[order]}</Select.Option>
                                        ))}
                                    </Select>
                                </span>
                                <Button size={'small'}
                                        onClick={()=>resetSearch()}
                                        style={{marginRight:5, fontSize:14}}>
                                    <UndoOutlined rotate={90}/>Reset Search</Button>
                            </>}
                            right={
                                <Pager total={result.total}
                                       pageSize={state.pageSize} onShowSizeChange={onPageSizeChange}
                                       current={state.page} onChange={onPageChange}
                                />}
                        />
                        <div >
                            {result.records.map((asset) =>
                                <AssetCard key={asset.id}
                                           asset={asset} type={'template'}
                                           onClick={() => onSelect(asset)}/>)}

                            {(state.page > 1 || state.page < (result.total / state.pageSize) ) &&
                            <Space align={'center'} direction={'vertical'} style={{display:'inline-block',margin:5}}>
                                    {state.page < (result.total / state.pageSize) &&
                                        <Button type={'link'} size={'large'}
                                                onClick={()=>onPageChange(state.page+1)}
                                                style={{fontSize:20,fontWeight:'bold'}}
                                        >
                                            Next <ArrowRightOutlined />
                                        </Button>}
                                    {state.page > 1 &&
                                        <Button type={'link'} size={'large'}
                                                onClick={()=>onPageChange(state.page-1)}
                                                style={{fontSize:20,fontWeight:'bold'}}
                                        >
                                            <ArrowLeftOutlined/> Back
                                        </Button>}
                                </Space>
                            }
                        </div>
                        <Spread
                            style={{background: '#eee', marginTop:10, borderRadius:5}}
                            left={<div style={{margin:5}}>Total: {result.total}</div>}
                            right={
                                <Pager total={result.total}
                                       pageSize={state.pageSize} onShowSizeChange={onPageSizeChange}
                                       current={state.page} onChange={onPageChange}
                                />}
                        />
                    </>
                    : <>
                        <Spread style={{background: '#EEE', borderRadius:5}}
                            left={
                                <Button
                                    size={'small'}
                                    onClick={()=>resetSearch()}
                                    style={{margin:5}}
                                >
                                    <UndoOutlined rotate={90}/>reset search</Button>
                            }
                        />
                        { result && result.total === 0
                        ? <div>
                            Your search did not return any results. <br/>
                            Click <Dropdown overlay={getRequestMenu(result.textQuery)}>
                                <a onClick={e => e.preventDefault()}>
                                    here<DownOutlined />
                                </a>
                            </Dropdown> to make a request for future library material.
                        </div>
                        : !loading && <div>
                            Search failed. Please try again.
                        </div>
                        }
                    </>}
            </Spin>
        </div>
    );
}

//TODO ?check result  statuts
function FilterCheckbox({label, ...props }){
    return <div style={{marginBottom:5}}>
        <h4>{label}</h4>
        <Checkbox.Group {...props}/>
    </div>
}


// create query string parameters for use with alternate mcc search
/*
function getUrlMccQuery({state, newFilters, filters}) {
    const mccQuery = {
        FREETEXT: state.keyword.join(' '),
        BATCHSIZE: state.pageSize,
        START: calcFirstRow({
            pageSize: state.pageSize,
            currentPage: state.page
        }),
        sort: state.sortOrder,
        id: now(),
        BOOLu23: 'spec ad',
        BOOLu20: 'has miad',
        BOOLl15: 'color',
        BOOLp21: 'metro newspaper service@classified dynamics@sales spectaculars@plus business@holiday adv. service@bonus@plus business',
        BOOLu27: '0@1@2@3@4@5@6',
        NOOLp85: excludedTypes.join('@')
    };
    if (state.exactMatch) {
        mccQuery.FREETEXT = '+' + mccQuery.FREETEXT.replace(/\s+/g, ' +');
    }
    if (state.notword.length > 0) {
        mccQuery.FREETEXT += ' ' + state.notword.join(' ');
    }

    newFilters.forEach(field => {
        if (isArray(state[field]) && state[field].length > 0) {
            const lookup = invert(filters[field].values);
            mccQuery[filters[field].tag] = Object.values(pick(lookup, state[field])).join('@');
        }
    });

    return mccQuery;
}
*/

// marshall search information for hook to build query using mcc.Query
function getApiMccInfo({queryData, newFilters, filters}) {

    const queryInfo = {
        pager: {
            batchSize: queryData.pageSize,
            start: calcFirstRow({
                pageSize: queryData.pageSize,
                currentPage: queryData.page
            }),
            order: queryData.sortOrder
        },
        search: {
            keywords: queryData.keyword.join(' '),
            exact_match: queryData.exactMatch,
            notwords: queryData.notword.join(' ')
        },
        filters: {
            has_miad: ['has miad'],
            color: ['color'],
            metro_type: ['spec ad'],
            sub_item_count: range(0, maxSubItemCount)
            // Service should be filled in by mcc.
            //BOOLp21: 'metro newspaper service@classified dynamics@sales spectaculars@plus business@holiday adv. service@bonus@plus business',
        },
        notFilters: {
            ad_type: excludedTypes
        },
    };

    if (queryData.holiday) (
        queryInfo.filters.service = ['holiday adv. service']
    )

    newFilters.forEach(field => {
        if (isArray(queryData[field]) && queryData[field].length > 0) {

            const lookup = invert(filters[field].values);
            queryInfo.filters[filters[field].name] =
                Object.values(pick(lookup, queryData[field]));
        }
    });

    return queryInfo;
}

/*
<RefreshButton title={'refresh search'}
   onRefresh={()=>dispatch({type:'forceUpdate'})}
   primary={result && result.status==='failed'}
/>
 */